import { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import Dashboard from './Dashboard/Dashboard'
import Login from './Login/Login'
import Logout, { logOut } from './Login/Logout'
import UploadFile from './UploadSound/UploadSound'
import "./Root.css"
import Register from './Register/Register'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'
import About from './About/About'
import { refreshToken } from './Login/RefreshTokens'
import LandingPage from './LandingPage/LandingPage'
import 'bootstrap/dist/css/bootstrap.min.css'
import { APP_DIRECTORY } from './SystemVariables'
import VerifyLinkHandler from './Register/VerifyLinkHandler'
import Profile from './Profile/Profile'

const getAccessToken = (tokens) => {
    if(tokens === undefined) {
        return undefined
    } else {
        return tokens.access
    }
}


const Root = () => {
    const [tokens, setTokens] = useState(undefined)
    const [username, setUsername] = useState(undefined)
    const [loaded, setLoaded] = useState(false)

    const clearLoginData = () => {
        logOut(setTokens, setUsername)
    }

    useEffect(() => {
        const accessTokenFromStorage = localStorage.getItem('accessToken')
        const refreshTokenFromStorage = localStorage.getItem('refreshToken')
        const storedUsername = localStorage.getItem('username')
        const tokensFromStorage = {access: accessTokenFromStorage, refresh: refreshTokenFromStorage}
        setTokens(tokensFromStorage)
        setUsername(storedUsername)
        setLoaded(true)
        const interval = setInterval(() => {
            refreshToken(setTokens, setUsername)
        }, 1000 * 60 * 60 * 1)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const accessToken = getAccessToken(tokens)

    if(!loaded) {
        return(<div className="soundboardRoot">Please wait...</div>)
    } else {
        return(<div className="soundboardRoot">
            <Switch>
                <Route exact path={`${APP_DIRECTORY}/`}>
                    <LandingPage accessToken={accessToken}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/soundboard`}>
                    <Dashboard accessToken={accessToken} username={username} clearLoginData={clearLoginData}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/uploadFile/:slotNumber`}>
                    <UploadFile accessToken={accessToken}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/login`}>
                    <Login setTokens={setTokens} setUsername={setUsername} accessToken={accessToken}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/logout`}>
                    <Logout setTokens={setTokens} setUsername={setUsername}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/register`}>
                    <Register setTokens={setTokens} setUsername={setUsername}/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/verify/:code`}>
                    <VerifyLinkHandler/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/about`}>
                    <About/>
                </Route>
                <Route exact path={`${APP_DIRECTORY}/profile`}>
                    <Profile accessToken={accessToken} username={username}/>
                </Route>
                <Route path={`${APP_DIRECTORY}/*`}>
                    <Redirect to={`${APP_DIRECTORY}/`}/>
                </Route>
            </Switch>
        </div>)
    }
}

export default Root
